/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_CtaInputs */

const en_mk_nav_cta = /** @type {(inputs: Mk_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started free`)
};

const id_mk_nav_cta = /** @type {(inputs: Mk_Nav_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis`)
};

/**
* | output |
* | --- |
* | "Get started free" |
*
* @param {Mk_Nav_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_cta = /** @type {((inputs?: Mk_Nav_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_cta(inputs)
	return en_mk_nav_cta(inputs)
});